import {Icon} from 'mc/lib';
import React, {PureComponent} from 'react';
import {Tooltip} from 'reactstrap';
import './Obdobi.scss';
import {formatObdobi, obdobiPropType} from './utils';

let lastId = 0;

/**
 * Komponenta pro zobrazení období.
 */
export default class Obdobi extends PureComponent {

    static propTypes = {
        obdobi: obdobiPropType.isRequired,
    };

    constructor(props) {
        super(props);
        this.id = ++lastId;
        this.state = {tooltipOpen: false};
    }

    handleToggleTooltip = () => {
        this.setState({tooltipOpen: !this.state.tooltipOpen});
    };

    render() {
        const {tooltipOpen} = this.state;
        const {obdobi} = this.props;
        const {upresneni} = obdobi;
        const iconId = 'obdobi-icon-' + this.id;

        return (
            <div className="obdobi">
                {formatObdobi(obdobi)}
                {upresneni && ' '}
                {upresneni && <Icon id={iconId} icon="file-o"/>}
                {upresneni && <Tooltip placement="top"
                                       target={iconId}
                                       isOpen={tooltipOpen}
                                       toggle={this.handleToggleTooltip}>{upresneni}</Tooltip>}
            </div>
        );
    }

}
